import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AwardsList from "./AwardsListe";
import LeaderofQuarterList from "./LeaderofQuarterList";
import StarofYearList from "./StarofYearList";



function LeaderQuarterListMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <LeaderofQuarterList/>
            </BasicCard>
        </>
    )
}
export default LeaderQuarterListMain;